"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShelveIdentify = void 0;
const PointLocation_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocation.js"));
const shelveTemplate_1 = require("./shelveTemplate");
const shelveRowGroup_1 = require("./shelveRowGroup");
const shelveRow_1 = require("./shelveRow");
const ShelveIdentifyDistance = 500; //识别单排或双排货架时的判断距离
class ShelveIdentify {
    //1.筛选剩下完全在框里面的线段
    //2.将所有线段进行分组（首尾相接的线段划分成同一个组）
    //3.然后匹配这些组的线段是否符合条件，符合条件则识别为货架
    extractTemplate(clipPolygonPoints, segments) {
        let templateSegments = new Array();
        for (let seg of segments) {
            //两个点都在多边形内才判断为模板的线段
            if (PointLocation_js_1.default.isInRing(seg.p0, clipPolygonPoints) && PointLocation_js_1.default.isInRing(seg.p1, clipPolygonPoints)) {
                templateSegments.push(seg);
            }
        }
        //移除被其他线段覆盖的线段，增加对数据的兼容性。（测试数据的货架底下就有些不为货架单元的线段）
        for (let i = templateSegments.length - 1; i >= 0; i--) {
            let seg1 = templateSegments[i];
            for (let j = 0; j < templateSegments.length; j++) {
                if (i == j)
                    continue;
                let seg2 = templateSegments[j];
                if (this.isSegmentOverlappedByAnother(seg1, seg2)) {
                    templateSegments.splice(i, 1);
                    break;
                }
            }
        }
        return new shelveTemplate_1.ShelveTemplate(templateSegments);
    }
    isSegmentOverlappedByAnother(seg, other) {
        return other.distance(seg.p0) < 1 && other.distance(seg.p1) < 1;
    }
    matchByTemplate(shelveTemplate, segments) {
        let matchGroups = shelveTemplate.initMatchGroupByFirstSegment(segments);
        let isLineSegmentUsed = new Array(segments.length).fill(false);
        for (let i = matchGroups.length - 1; i >= 0; i--) {
            let matchGroup = matchGroups[i];
            //没有匹配上的Group从数组里移除
            if (!shelveTemplate.matchTheRestSegments(segments, matchGroup, isLineSegmentUsed)) {
                matchGroups.splice(i, 1);
            }
        }
        return matchGroups;
    }
    //分行
    divideIntoRows(shelves) {
        let rows = new Array();
        for (let shelve of shelves) {
            let boundingBox = shelve.getBoundingBox();
            let center = boundingBox.getCenter();
            let matchToRow = false;
            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row.isBelongToThisRow(center.y)) {
                    row.addShelve(shelve);
                    matchToRow = true;
                    break;
                }
            }
            if (!matchToRow)
                rows.push(new shelveRow_1.ShelveRow(shelve));
        }
        //按X值排个序（从左往右，小的在前）
        for (let row of rows) {
            row._shelves.sort(function (a, b) { return a.getBoundingBox().getCenter().x - b.getBoundingBox().getCenter().x; });
        }
        //按每行的Y排个序（从上往下，大的在前）
        rows.sort(function (a, b) { return b.getCenterY() - a.getCenterY(); });
        return rows;
    }
    //货架分组
    groupingRows(shelveRows) {
        let groups = [new shelveRowGroup_1.ShelveRowGroup(shelveRows[0])];
        for (let i = 1; i < shelveRows.length; i++) {
            let previousRow = shelveRows[i - 1];
            let currentRow = shelveRows[i];
            if (previousRow._shelves[0].getBoundingBox().min.y - currentRow._shelves[0].getBoundingBox().max.y < ShelveIdentifyDistance) {
                groups[groups.length - 1].addRow(currentRow);
            }
            else {
                groups.push(new shelveRowGroup_1.ShelveRowGroup(currentRow));
            }
        }
        //检查group里有没有大于2的异常数据
        for (let group of groups) {
            if (group._shelveRows.length > 2) {
                throw Error("货架行数大于2");
            }
        }
        return groups;
    }
}
exports.ShelveIdentify = ShelveIdentify;
